import{pathBuilder}from'./index';export var root='/admin/transfer_events';export default pathBuilder(root);